import flow from "lodash/flow";
import { LightButton } from "../../../../components/buttons/buttons";
import Modal from "../../../../components/modals/modal/modal";
import { currencyFormat, nullary } from "../../../../core/utils";
import { ModalProps } from "../../../../core/utils/modals";
import { DatosDomiciliacion } from "../types/pagos.types";

type DomiciliacionExitosaModalProps = ModalProps & {
	datos?: Partial<DatosDomiciliacion>;
	descargarComprobante: VoidFunction;
};

const DomiciliacionExitosaModal = ({ parent, onClosed, datos = {}, descargarComprobante }: DomiciliacionExitosaModalProps) => {
	const footer = (close: VoidFunction) => (
		<>
			<LightButton className="me-5" onClick={nullary(flow(descargarComprobante, close))}>Descargar</LightButton>
			<LightButton className="ml-5" onClick={nullary(flow(window.print, close))}>Imprimir</LightButton>
		</>
	);

	return (
		<Modal parent={parent} title="" dialogClassName="domiciliar-pago" footer={footer} onClosed={onClosed}>
			<div className="col-12" >
				<div className="comprobante-banorte">
					<div className="c-header">
						<span>Domiciliación exitosa</span>
					</div>
					<div className="c-body">
						<div className="row">
							<div className="col-12">
								<table className="border-b">
									<tbody>
										<tr>
											<td>Nombre</td>
											<td>{datos.nombre}</td>
										</tr>
										<tr>
											<td>Correo electrónico</td>
											<td>{datos.correoElectronico}</td>
										</tr>
										<tr>
											<td>Teléfono</td>
											<td>{datos.telefono}</td>
										</tr>
										<tr>
											<td>RFC o CURP</td>
											<td>{datos.rfcCurp}</td>
										</tr>
										<tr>
											<td>Tipo de persona</td>
											<td>{datos.tipoPersona}</td>
										</tr>
										<tr>
											<td>Tipo de identificación</td>
											<td>{datos.tipoIdentificacion}</td>
										</tr>
										<tr>
											<td>Número de identificación</td>
											<td>{datos.numeroIdentificacion}</td>
										</tr>
										<tr>
											<td>Cuenta</td>
											<td>{datos.cuentaTarjetaClabe}</td>
										</tr>
										<tr>
											<td>Banco</td>
											<td>{datos.banco}</td>
										</tr>
										<tr>
											<td>Monto máximo del cargo autorizado</td>
											<td>{currencyFormat(datos.montoMaximo)} MN</td>
										</tr>
										<tr>
											<td>Concepto de pago</td>
											<td>
												{datos.concepto}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default DomiciliacionExitosaModal;